import {
    ValgStateActionTypes,
    ValgState,
    TOGGLE_UTBETALINGSPLAN,
    TOGGLE_FORDELING,
    TOGGLE_VILKAR,
    UPDATE_VALG,
} from './Types';

export const initialState: ValgState = {
    aStotte: undefined,
    bSemester: undefined,
    bxSemester: undefined,
    cSp: undefined,
    cxSp: undefined,
    dBosted: undefined,
    eSkolepenger: undefined,
    fSpBelop: undefined,
    visUtbetalingsplan: false,
    visFordeling: false,
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                // Reset to inital state when aStotte is changed
                if (action.payload.aStotte) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_UTBETALINGSPLAN: {
                return {
                    ...state,
                    visUtbetalingsplan: !state.visUtbetalingsplan,
                };
            }
            case TOGGLE_FORDELING: {
                return {
                    ...state,
                    visFordeling: !state.visFordeling,
                };
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            default:
                return state;
        }
    }
}
